<div class="block-toggle">
  {{upperText}}
  <span class="link" (click)="toggleItemsVisibility()">{{ isShowing ? 'скрыть' : 'показать' }}</span>
</div>

<div class="block-title">
  {{title}} <span class="block-counter" *ngIf="counter != -1">{{ counter }}</span>
</div>

<div class="block-items" *ngIf="isShowing" [@slideDown]>
  <ng-content></ng-content>
</div>
